const routes = [
    {
        path: "/pilotage/prices",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "pilotageprice_index",
        }
    }
];

export default routes;
